import notificationsUtil from './notificationsUtil';

angular.module('signalview.notifications', []).service('notificationsUtil', notificationsUtil);
